const firebaseConfig = {
    apiKey: "AIzaSyDnywZCwphO2KMKUrX4-5bXTqU9yeRjk5o",
    authDomain: "travel-guru-project-final.firebaseapp.com",
    databaseURL: "https://travel-guru-project-final.firebaseio.com",
    projectId: "travel-guru-project-final",
    storageBucket: "travel-guru-project-final.appspot.com",
    messagingSenderId: "1058091412425",
    appId: "1:1058091412425:web:6c661cf64ef40ca0549618"
  };

  export default firebaseConfig;